import { Action, Dispatch } from 'redux';
import { SelectOptionType } from '../utils/selection';

export interface ILiveAssetFilters {
  exchangeLiveEvent?: boolean;
  securityProfiles?: string[];
  start?: string[];
  textSearch?: string;
  streamStatus?: string;
}

export interface IState {
  filters: object;
  liveAssetFilters: ILiveAssetFilters;
  selectedFilterOptions: {
    [key: string]: Array<SelectOptionType<string>>;
  }
}

export enum ActionType {
  UpdateFilterValues = 'FilterAssets.UpdateFilterValues',
  ClearAllFilters = 'FilterAssets.ClearAllFilters',
  UpdateSelectedFilterOptions = 'FilterAssets.UpdateSelectedFilterOptions',
  UpdateLiveFilterOptions = 'FilterAssets.UpdateLiveFilterOptions',
}
export interface IFilterAssets extends Action<ActionType> {
  payload?: any,
}

export const INITIAL_STATE: IState = {
  filters: {},
  liveAssetFilters: {
    exchangeLiveEvent: false,
    textSearch: '',
    securityProfiles: null,
    start: null,
  },
  selectedFilterOptions: {},
};

export default function reducer(state: IState = INITIAL_STATE, action: IFilterAssets): IState {
  switch (action.type) {
    case ActionType.UpdateFilterValues:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.ClearAllFilters:
      return {
        filters: INITIAL_STATE.filters,
        liveAssetFilters: INITIAL_STATE.liveAssetFilters,
        selectedFilterOptions: INITIAL_STATE.selectedFilterOptions,
      };
    case ActionType.UpdateSelectedFilterOptions:
      return {
        ...state,
        selectedFilterOptions: {
          ...state.selectedFilterOptions,
          [action.payload.assetKey]: action.payload.options,
        },
      };
    case ActionType.UpdateLiveFilterOptions:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const updateFilterValues = (filters: object) => async (dispatch: Dispatch<IFilterAssets>) => {
  dispatch({
    payload: {
      filters,
    },
    type: ActionType.UpdateFilterValues,
  });
};

export const updateLiveFilterValues = (liveAssetFilters: object) => async (dispatch: Dispatch<IFilterAssets>) => {
  dispatch({
    payload: {
      liveAssetFilters,
    },
    type: ActionType.UpdateLiveFilterOptions,
  });
};

export const clearAllFilters = () => ({
  type: ActionType.ClearAllFilters,
});

export const updateSelectedFilterOptions = (assetKey: string, options: Array<SelectOptionType<string>>): IFilterAssets => ({
  type: ActionType.UpdateSelectedFilterOptions,
  payload: {
    assetKey,
    options,
  },
});
